import React from "react";
import POIsAttachments from "./POIsAttachments";
import POIsAttributes from "./POIsAttributes";
import POIsLogo from "./POIsLogo";

export default function POIsExtra({ addPOI, poiAttachments }) {
	return (
		<>
			<POIsLogo addPOI={addPOI} />
			<POIsAttachments addPOI={addPOI} poiAttachments={poiAttachments} />
			<POIsAttributes addPOI={addPOI} />
		</>
	);
}
